var _path, _path2, _path3, _ellipse, _ellipse2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccompagnement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 135,
    viewBox: "0 0 143 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.400024 115.68C0.400024 90.4516 20.8516 70 46.0799 70C71.3081 70 91.7597 90.4516 91.7597 115.68V119.334H0.400024V115.68Z",
    fill: "#5E89C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 115.68C51 90.4516 71.4516 70 96.6798 70C121.908 70 142.36 90.4516 142.36 115.68V119.334H51V115.68Z",
    fill: "#1956A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 119.332H91.7193V115.678C91.7193 99.8152 83.634 85.8411 71.3597 77.6517C59.0854 85.8411 51 99.8152 51 115.678V119.332Z",
    fill: "#FFA05C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.7596,
    cy: 38.1265,
    rx: 23.4496,
    ry: 23.4496,
    fill: "#5E89C2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.4433,
    cy: 38.1266,
    rx: 23.4496,
    ry: 23.4496,
    fill: "#1956A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccompagnement);
export default __webpack_public_path__ + "static/media/Accompagnement.231d3722f02eada18bd7f0ea3ee44d63.svg";
export { ForwardRef as ReactComponent };